import React from 'react';
import { Route, BrowserRouter as Router, Routes,  } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Header from './components/Header';
import Footer from './components/Footer';
import Services from './components/Services';
import Franchaise from './components/Franchaise';
import PersonalTaxation from './components/PersonalTaxation';
import BusinessTaxation from './components/BusinessTaxation';
import GeneralTaxation from './components/GeneralTaxation';
import BusinessRegistration from './components/BusinessRegistration';
import FillingReturns from './components/FillingReturns';
import BudgetingCashFlow from './components/BudgetingCashFlow';
import ContactUs from './components/ContactUs';
import { FolderMinus } from 'lucide-react';
import FormsComponent from './components/FormsComponent';
import AboutUs from './components/AboutUs';
import WhatsAppButton from './components/WhatsAppButton';

function App() {
  return (
    <Router>
      <WhatsAppButton/>
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        {/* <Route path="/services" element={<Services />} /> */}
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/forms" element={<FormsComponent />} />

        
        <Route path="/franchise" element={<Franchaise />} />
        <Route path="/generaltax" element={<GeneralTaxation />} />
        <Route path="/fillingreturns" element={<FillingReturns />} />
        <Route path="/cashflow" element={<BudgetingCashFlow />} />




        <Route path="/personaltax" element={<PersonalTaxation />} />
        <Route path="/businesstaxation" element={<BusinessTaxation />} />
        <Route path="/businessregistration" element={<BusinessRegistration />} />


        

        {/* <Route path="/contactus" element={<ContactUs />} /> */}
      </Routes>
      <Footer />

      {/* WhatsApp button will appear on all pages */}
      {/* <WhatsAppButton /> */}
    </Router>
  );
}

export default App;
